import { createRoute } from '@tanstack/react-router'
import { Route as appLayoutRoute } from '../layout'

export const Route = createRoute({
  getParentRoute: () => appLayoutRoute,
  path: '/crm/activities',
}).lazy(() => import('./activities.lazy').then((d) => d.Route))
